import React, { useCallback } from 'react';
import ChevronDownIcon from '@atlaskit/icon/glyph/chevron-down';
import ChevronRightIcon from '@atlaskit/icon/glyph/chevron-right';
import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';
import Tooltip from '@atlaskit/tooltip';
import { useIntl } from '@atlassian/jira-intl';
import { fireUIAnalytics, useAnalyticsEvents } from '@atlassian/jira-product-analytics-bridge';
import messages from './messages';
import { ExpandIconWrapper } from './styled';

export const ExpandIcon = ({
	expanded,
	onClick,
	rowIndex,
	totalGroupItems,
}: {
	expanded: boolean;
	rowIndex?: number;
	totalGroupItems: number;
	onClick: () => void;
}) => {
	const { formatMessage } = useIntl();
	const Icon = expanded ? ChevronDownIcon : ChevronRightIcon;
	const { createAnalyticsEvent } = useAnalyticsEvents();

	const handleClick = useCallback(() => {
		onClick();
		fireUIAnalytics(createAnalyticsEvent({}), 'button clicked', 'listRowGroupExpandIcon', {
			direction: expanded ? 'collapse' : 'expand',
			totalGroupItems,
		});
	}, [createAnalyticsEvent, expanded, onClick, totalGroupItems]);

	return (
		<Tooltip position="top" content={formatMessage(expanded ? messages.collapse : messages.expand)}>
			<ExpandIconWrapper
				onClick={handleClick}
				iconBefore={
					<Icon
						label={formatMessage(expanded ? messages.collapseLabel : messages.open)}
						primaryColor={token('color.text.subtle', colors.N200)}
					/>
				}
				appearance="subtle"
				testId={`business-list.ui.list-view.group-item.expand-icon.expand-icon-wrapper-${rowIndex}`}
			/>
		</Tooltip>
	);
};
